// mutations
const ACADEMIC_COURSES_ALL = (state, academicCourse) => {
    if (academicCourse.code === 1) {
      state.academicCourse = academicCourse.data
      state.status = 'success'
    } else {
      alert(academicCourse.message)
      state.status = 'error'
    }
  }
  
  export default {
    ACADEMIC_COURSES_ALL
  }
  


// WEBPACK FOOTER //
// ./src/store/modules/academic/courses/mutations.js